import { MediaDTO } from '../media';
import type { FinancialClass } from '../investments/financials';

export type TransactionType = 'EXPENSE' | 'INCOME';

export const transactionIncomeCategories = [
  'RENTAL_INCOME',
  'TENANT_RECHARGES_INCOME',
  'DEPOSIT_WITHHELD',
  'SALE_INCOME',
  'OTHER_INCOME',
] as const;

export const transactionExpenseCategories = [
  'FINANCING_INTEREST',
  'LOAN_PRINCIPAL',
  'REPAIRS_MAINTENANCE',
  'IMPROVEMENT',
  'LOCAL_TAXES',
  'COMMUNITY_FEES',
  'UTILITIES',
  'INSURANCE',
  'PROFESSIONAL_SERVICES',
  'LEGAL_DEFENSE',
  'RENTAL_MANAGEMENT',
  'CLEANING',
  'BAD_DEBT',
  'DEPRECIATION_PROPERTY',
  'DEPRECIATION_FURNITURE',
  'ACQUISITION_COSTS',
  'SALE_COSTS',
  'OTHER_DEDUCTIBLE_EXPENSE',
  'NON_DEDUCTIBLE_EXPENSE',
  'REVIEW',
] as const;

export const transactionCategories = [
  ...transactionIncomeCategories,
  ...transactionExpenseCategories,
] as const;

export type TransactionCategory = (typeof transactionCategories)[number];

export type PaymentMethod = 'CASH' | 'BANK_TRANSFER' | 'CARD' | 'DIRECT_DEBIT';

export interface InvestmentTransactionLineDTO {
  id: string;
  category: TransactionCategory;
  amount: number;
  financialClass: FinancialClass;
  classificationSource: 'AUTOMATIC' | 'EXPLICIT';
}

export interface InvestmentTransactionDTO {
  id: string;
  investmentId: string;
  type: TransactionType;
  category: TransactionCategory;
  concept?: string;
  amount: number;
  lines: InvestmentTransactionLineDTO[];
  date: string;
  paymentMethod?: PaymentMethod;
  documentId?: string;
  document?: MediaDTO;
  rentAllocations: RentPaymentAllocationDTO[];
  createdAt: string;
  updatedAt: string;
}

export interface RentPaymentAllocationDTO {
  id: string;
  rentChargeId: string;
  amount: number;
  month?: string;
}

export interface TransactionStatsDTO {
  totalExpenses: number;
  totalIncome: number;
  netCashflow: number;
  expenseCount: number;
  incomeCount: number;
  expensesByCategory: Record<string, number>;
  incomesByCategory: Record<string, number>;
}
